import type { TSimuladorSchema } from '@/domain/simulador/types/simulacao.type'
import { Empreendimento } from '@/features/simulador/brasil/domain/empreendimento'
import type { TTipoProdutoPrecificadoBrasilEnum } from '@/types/produto'
import type { TTipoAmortizacaoEnum } from '@/types/simulacao'

import { SimulacaoFactory } from './simulacao-factory'

export class EmpreendimentoFactory {
  static create(
    idExterno: string,
    nome: string,
    tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum,
    tipoAmortizacao?: TTipoAmortizacaoEnum | null,
  ): Empreendimento {
    return new Empreendimento(idExterno, nome, tipoDoProduto, tipoAmortizacao)
  }

  static fromFormData(
    empreendimentoData: TSimuladorSchema['empreendimentos'][number],
    tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum,
    tipoDeAmortizacaoDefault?: TTipoAmortizacaoEnum | null,
  ): Empreendimento {
    const emp = new Empreendimento(
      empreendimentoData.idExterno,
      empreendimentoData.nome,
      tipoDoProduto,
      tipoDeAmortizacaoDefault ?? empreendimentoData.simulacoes[0]?.simulacao.tipoDeAmortizacao,
    )

    for (const simulacaoData of empreendimentoData.simulacoes) {
      if (simulacaoData.tipoDeAmortizacao === 'SacocV') {
        const simulacao = SimulacaoFactory.create(
          simulacaoData.tipoDeAmortizacao,
          simulacaoData.simulacao.formaDePagamento,
        )
        emp.addSimulacaoExistente(simulacao)
      } else {
        const simulacao = SimulacaoFactory.create(simulacaoData.tipoDeAmortizacao)
        emp.addSimulacaoExistente(simulacao)
      }
    }

    return emp
  }
}
